angular.module('FlexyBeautyApp.services')
    .factory('BookingCreator', ['gettextCatalog', 'Brand', function (gettextCatalog, Brand) {
        let labelTreatwell = gettextCatalog.getString("par treatwell"),
            labelGoogle = gettextCatalog.getString("par google"),
            labelWeb = gettextCatalog.getString("par internet"),
            labelAppMobile = gettextCatalog.getString("par l'application mobile"),
            labelBackOffice = gettextCatalog.getString("par l'agenda"),
            labelMarketplace = gettextCatalog.getString("par " + Brand.marketplace.label),
            labelBackOfficeKiutePro = gettextCatalog.getString("par l'application mobile android");

        return {
            WEBSITE: {
                key: "WEBSITE",
                code: "internet",
                label: labelWeb
            },
            RWG: {
                key: "RWG",
                code: "google",
                label: labelGoogle
            },
            TREATWELL: {
                key: "TREATWELL",
                code: "treatwell",
                label: labelTreatwell
            },
            BACKOFFICE: {
                key: "BACKOFFICE",
                code: "backoffice",
                label: labelBackOffice
            },
            APPMOBILE_PRO: {
                key: "APPMOBILE_PRO",
                code: "appmobilePro",
                label: labelAppMobile
            },
            APPMOBILE_CLI: {
                key: "APPMOBILE_CLI",
                code: "appmobileCli",
                label: labelAppMobile
            },
            LE_CISEAU: {
                key: "LE_CISEAU",
                code: "leCiseau",
                label: labelMarketplace
            },
            BACKOFFICE_KIUTE_PRO: {
                key: "BACKOFFICE_KIUTE_PRO",
                code: "backofficeKiutePro",
                label: labelBackOfficeKiutePro
            }
        };
    }]);



// WEBPACK FOOTER //
// ./js/services/views/ConstantsBookingCreator.js